import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import PDFViewer from './Viewers/PDFViewer';

const PreviewDocument = ({ type, fileUrl, options, tip, loading }) => {
  const ViewerComponent = React.useMemo(() => {
    if (type === 'pdf') return PDFViewer;
    return null;
  }, [type]);

  if (!ViewerComponent) return <div>Unsupported file type</div>;

  return (
    <Spin tip={tip} spinning={loading}>
      <div
        style={{
          flexGrow: 1,
        }}>
        {fileUrl ? <ViewerComponent fileUrl={fileUrl} options={options} /> : null}
      </div>
    </Spin>
  );
};
PreviewDocument.propTypes = {
  type: PropTypes.string.isRequired,
  fileUrl: PropTypes.string.isRequired,
  options: PropTypes.object,
};

PreviewDocument.defaultProps = {
  options: {},
};

export default PreviewDocument;
